import { render } from "./Token.vue?vue&type=template&id=71e8c765&scoped=true&ts=true"
import script from "./Token.vue?vue&type=script&lang=ts"
export * from "./Token.vue?vue&type=script&lang=ts"

import "./Token.vue?vue&type=style&index=0&id=71e8c765&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e8c765"]])

export default __exports__